import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteDiscordServerMutationVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;

export type DeleteDiscordServerMutation = {
  __typename?: 'Mutation';
  deleteDiscordServer: boolean;
};

export const DeleteDiscordServerDocument = gql`
  mutation DeleteDiscordServer($id: UUID!) {
    deleteDiscordServer(id: $id)
  }
`;
export type DeleteDiscordServerMutationFn = Apollo.MutationFunction<
  DeleteDiscordServerMutation,
  DeleteDiscordServerMutationVariables
>;

/**
 * __useDeleteDiscordServerMutation__
 *
 * To run a mutation, you first call `useDeleteDiscordServerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDiscordServerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDiscordServerMutation, { data, loading, error }] = useDeleteDiscordServerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDiscordServerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteDiscordServerMutation,
    DeleteDiscordServerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteDiscordServerMutation,
    DeleteDiscordServerMutationVariables
  >(DeleteDiscordServerDocument, options);
}
export type DeleteDiscordServerMutationHookResult = ReturnType<
  typeof useDeleteDiscordServerMutation
>;
export type DeleteDiscordServerMutationResult =
  Apollo.MutationResult<DeleteDiscordServerMutation>;
export type DeleteDiscordServerMutationOptions = Apollo.BaseMutationOptions<
  DeleteDiscordServerMutation,
  DeleteDiscordServerMutationVariables
>;
